<template>
  <div class="container">
    <v-btn
      icon="mdi-source-branch"
      color="blue"
      class="info-block"
      @click="showBuildMetaDataToast"
    />
  </div>
</template>

<script setup lang="ts">
import { AppLayoutBuildMetaDataToast } from '#components';

const showBuildMetaDataToast = () => {
  useToast()(AppLayoutBuildMetaDataToast, { closeOnClick: false });
};
</script>

<style lang="scss" scoped>
.container {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  z-index: 2000;
  pointer-events: none;
}

.info-block {
  position: absolute;
  right: 0;
  bottom: 0;
  height: 32px;
  width: 32px;
  margin: 16px;
  pointer-events: auto;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 0 16px 0 rgb(var(--v-theme-blue64));
}
</style>
